import SectionHeading from "./SectionHeading";
import { guideSteps, collectorImage } from "@/mocks/highlights";

export default function Guide() {
  return (
    <section id="guide" className="w-full bg-background-100/70 px-4 py-16 md:px-8 md:py-24">
      <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
        <div className="relative mx-auto w-full max-w-md overflow-hidden rounded-2xl border border-background-200 bg-background-50">
          <div className="aspect-[9/10] w-full">
            <img
              src={collectorImage}
              alt="书桌上摆放光盘、海报与观剧笔记的动漫风格插画"
              className="h-full w-full object-top"
            />
          </div>
          <div className="absolute bottom-4 left-4 right-4 rounded-lg border border-background-200 bg-background-50/95 p-3.5">
            <p className="text-xs text-foreground-500">追番小贴士</p>
            <p className="mt-1 text-sm text-foreground-800">
              把「想看」和「在追」分开记录，进度管理会轻松很多。
            </p>
          </div>
        </div>

        <div>
          <SectionHeading
            eyebrow="追番指南"
            title="四步建立自己的追番节奏"
            description="不追求一次看完当季所有作品，先建立可持续的节奏，再逐步扩大清单，反而更不容易弃番。"
          />

          <ol className="mt-8 space-y-4">
            {guideSteps.map((step) => (
              <li
                key={step.step}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-sm text-accent-800">
                  {step.step}
                </span>
                <div>
                  <h3 className="text-base text-foreground-950">{step.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{step.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}